module.exports = __webpack_public_path__ + "img/wyndham-garden-logo-color.89d3875a.svg";